<template>
    <div class="vm-guide">
        <div @click="$mixin_router_push(url, true)" v-if="type_pre == '1'" class="flex-box flex-a-center block" :class="{'flex-center': browser_size != 'small'}">
            <div class="img-box">
                <pic class="block" width="100" height="100" :src="cover"></pic>
            </div>
            <div>
                <div class="fs-24-12 mq fwb">{{$t('c.Guide.text1')}}</div>
                <div class="fs12 black-5" v-if="browser_size != 'small'">Creator Guides</div>
            </div>
        </div>
        <div v-if="type_pre == '2'" class="inner-box">
            <div class="img-box">
                <pic width="193" height="176" :src="cover"></pic>
            </div>
            <div>
                <div class="fs24 fwb">{{$t('c.Guide.text2')}}</div>
                <div class="fs12 black-5 mt8">{{$t('c.Guide.text3')}}</div>
                <div @click="$mixin_router_push(url, true)">
                  <btn class="size48 mt-32-16 mq">{{$t('c.Guide.text4')}}</btn>
                </div>
            </div>
            <i class="afd afd-x gl-hover-text black-3" @click="close"></i>
        </div>
    </div>
</template>

<script>
import { POST_CREATOR_SHOW_GUIDE } from "../api/config";
import { mapState } from "vuex";
export default {
  name: "guide",
  props: {
    type: {
      default() {
        return "1";
      }
    }
  },
  components: {},
  data() {
    return {
      type_pre: this.type,
      cover: `${this.GL.PIC_HOST}/static/img/afd-icon-guide@2x.png`,
      url: "/album/248b4bb2c9b111e9a9bb52540025c377/2da755247a8911e8ad6d52540025c377"
    };
  },
  computed: {
    ...mapState("app", ["session_user",'browser_size'])
  },
  mounted() {},
  methods: {
    async close() {
       let re = await this.$mixin_confirm({title:'是否确认隐藏？ 可在管理面板里继续查看'})
        if (!re) {
            return false;
        }
      if (this.$http.is_run(POST_CREATOR_SHOW_GUIDE)) {
        return false;
      }
      let data = await this.$http.$axios(POST_CREATOR_SHOW_GUIDE, {
        status: 0
      });
      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: "error"
        });
        return false;
      }
      this.session_user.creator.show_guide = 0;
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-guide {
    box-shadow: $layer-shadow;
    background: $white;

    .img-box {
        width: px2rem(100);
        height: px2rem(100);
        margin-right: px2rem(24);
    }

    .inner-box {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: px2rem(24) 0;
        position: relative;

        .img-box {
            width: px2rem(193);
            height: px2rem(176);
            margin-right: px2rem(37);
        }
    }

    .afd-x {
        position: absolute;
        right: px2rem(18);
        top: px2rem(18);
    }

    @media (max-width: $width-mobile) {
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
        border-radius: 1px;
        padding: 8px 16px;
        margin:0 8px;

        .img-box {
            width: auto;
            height: auto;
            margin-right: 8px;
            
            img{
              width:24px;
            }
        }

        .inner-box {
            padding: px2rem(24) px2rem(16);
            flex-direction: column;

            .img-box {
                margin-right: 0;
            }
        }
    }
}
</style>
